import { useParams } from "react-router-dom";

export const useContestAgreementId = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    throw new Error("Contest agreement ID is required");
  }

  return id;
};
